<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="frontmatter" id="ser">
<p class="sert"><a class="page" id="pii"></a><span class="sm">AMERICAN</span> <span class="sm">BEGINNINGS,</span> <span class="sm">1500–1900</span></p>
<p class="sered" style="text-align:center;">A Series Edited by Edward Gray, Stephen Mihm, and Mark Peterson</p>
<p class="serah" style="font-style: normal;"><span class="sm">ALSO</span> <span class="sm">IN</span> <span class="sm">THE</span> <span class="sm">SERIES:</span></p>
<p class="seraft"><i>Urban Dreams, Rural Commonwealth: The Rise of Plantation Society in the Chesapeake</i></p>
<p class="serau">by Paul Musselwhite</p>
<p class="ser"><i>Building a Revolutionary State: The Legal Transformation of New York, 1776–1783</i></p>
<p class="serau">by Howard Pashman</p>
<p class="ser"><i>Sovereign of the Market: The Money Question in Early America</i></p>
<p class="serau">by Jeffrey Sklansky</p>
<p class="ser"><i>National Duties: Custom Houses and the Making of the American State</i></p>
<p class="serau">by Gautham Rao</p>
<p class="ser"><i>Liberty Power: Antislavery Third Parties and the Transformation of American Politics</i></p>
<p class="serau">by Corey M. Brooks</p>
<p class="ser"><i>The Making of Tocqueville’s America: Law and Association in the Early United States</i></p>
<p class="serau">by Kevin Butterfield</p>
<p class="ser"><i>Planters, Merchants, and Slaves: Plantation Societies in British America, 1650–1820</i></p>
<p class="serau">by Trevor Burnard</p>
<p class="ser"><i>Riotous Flesh: Women, Physiology, and the Solitary Vice in Nineteenth-Century America</i></p>
<p class="serau">by April R. Haynes</p>
<p class="ser"><i>Holy Nation: The Transatlantic Quaker Ministry in an Age of Revolution</i></p>
<p class="serau">by Sarah Crabtree</p>
<p class="ser"><i>A Hercules in the Cradle: War, Money, and the American State, 1783–1867</i></p>
<p class="serau">by Max M. Edling</p>
<p class="ser"><i>Frontier Seaport: Detroit’s Transformation into an Atlantic Entrepôt</i></p>
<p class="serau">by Catherine Cangany</p>
<p class="ser"><i>Beyond Redemption: Race, Violence, and the American South after the Civil War</i></p>
<p class="serau">by Carole Emberton</p>
<p class="ser"><i>The Republic Afloat: Law, Honor, and Citizenship in Maritime America</i></p>
<p class="serau">by Matthew Taylor Raffety</p>
<p class="ser"><i>Conceived in Doubt: Religion and Politics in the New American Nation</i></p>
<p class="serau">by Amanda Porterfield</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-hart-0003.vue?4b1c15c9